<script>
import Swiper from 'swiper';
export default {
    props: ['index', 'templatesCount'],
    data() {
        return {
            swiper: null,
        };
    },
    mounted() {
        this.swiper = new Swiper(`.template-category-${this.index}`, {
            slidesPerView: 3,
            spaceBetween: 0,
            slidesPerGroup: 1,
            loop: this.loop,
            navigation: {
                nextEl: `.next-${this.index}`,
                prevEl: `.prev-${this.index}`
            },
            keyboard: {
                enabled: true,
                onlyInViewport: false,
            },
            breakpoints: {
                991: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                }
            },
        });
    },
    destroyed() {
        this.swiper.destroy();
        this.swiper = null;
    },
    computed: {
        loop() {
            if (this.templatesCount > 3) {
                return true;
            } 
            return false;
        }
    }
};
</script>
<style lang="less" scoped>
    .swiper-button-disabled{
        display:none;
    }
    .swiper-button-prev:focus{
        outline:none;
    }
    .swiper-button-next:focus{
        outline:none;
    }
    .swiper-button-prev{
        position:absolute;
        left:-50px;
        height: 40px;
        width: 40px;
        color: #2795FF;
        background-image: none;
        font-size: 16px;
        border-radius: 50%;
        border: 1px solid #eee;
        justify-content: center;
        align-items: center;
        display: flex;
        transform: rotate(180deg);
    }
    .swiper-button-next{
        position:absolute;
        right:-50px;
        height: 40px;
        width: 40px;
        color: #2795FF;
        background-image: none;
        font-size: 16px;
        border-radius: 50%;
        border: 1px solid #eee;
        justify-content: center;
        align-items: center;
        display: flex;
    }
    .nav-button-wrapper{
        position:relative;
        width:100%;
        margin-bottom: 30px;
    }
    .arrows {
        transition: 0.3s;
        opacity: 0;
        @media (max-width: 768px) {
            display:none;
        }
    }
    .nav-button-wrapper:hover .arrows {
        transition: 0.3s;
        opacity:1;
    }
    .arrows:hover {
        transition: 0.3s;
        opacity:1;
    }
    .swiper-container .swiper-wrapper{
        margin-bottom:0px;
    }
    .swiper-button-next.swiper-button-disabled, .swiper-button-prev.swiper-button-disabled {
        opacity: 0;
    }
</style>


// WEBPACK FOOTER //
// resources/js/frontend/components/SwiperSlider.vue